import { assignInlineVars } from '@vanilla-extract/dynamic'
import { borderColorVar, divider } from './Divider.css'

export function Divider({ color }: { color?: string }) {
  return (
    <hr
      className={divider}
      style={{
        ...assignInlineVars({
          [borderColorVar]: color,
        }),
      }}
    />
  )
}
